import React from 'react';
const milestones = [{
  title: 'Transparent Milestones',
  body: 'Progress tracking you can count on'
}, {
  title: 'Regular Updates',
  body: 'Stakeholder communication at every step'
}, {
  title: 'On-Time Delivery',
  body: 'Comprehensive documentation included'
}];
export function ProjectManagement() {
  return <section className="py-20 bg-surface border-y border-border texture-light" data-id="element-329">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-330">
        <div className="max-w-4xl mx-auto text-center scroll-fade-in-up" data-id="element-331">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6" data-id="element-332">
            Structured Delivery, Clear Communication
          </h2>
          <p className="text-lg text-muted mb-12 leading-relaxed" data-id="element-333">
            Every Magnus Software project follows a proven methodology:
            discovery and planning, iterative development with regular
            check-ins, thorough testing and quality assurance, and smooth
            deployment with documentation. You'll always know where your project
            stands, what's next, and when to expect delivery.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12" data-id="element-334">
            {milestones.map(({
            title,
            body
          }) => <div key={title} className="card-premium border border-border p-6 rounded-xl" data-id="element-335">
                <h3 className="text-xl font-bold text-ink mb-2" data-id="element-336">{title}</h3>
                <p className="text-muted" data-id="element-337">{body}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}